import { GradientBackground } from "../components/landing/GradientBackground";
import { Hero } from "../components/landing/Hero";
import { HowItWorks } from "../components/landing/HowItWorks";
import { Manifesto } from "../components/landing/Manifesto";
import { AudienceSplit } from "../components/landing/AudienceSplit";
import { Testimonials } from "../components/landing/Testimonials";
import { MeetCoach } from "../components/landing/MeetCoach";
import { BetaOffer } from "../components/landing/BetaOffer";
import { Footer } from "../components/landing/Footer";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="relative w-full">
      <GradientBackground />
      <Hero />
      <HowItWorks />
      <Manifesto />
      <AudienceSplit />
      <Testimonials />
      <MeetCoach />
      <BetaOffer />
      <Footer />
    </div>
  );
}
